import { MatchingRebateCardInterface } from '../../../../types';

const MatchingRebateCard = ({
  icon,
  rebateTitle,
  rebateDescription,
}: MatchingRebateCardInterface) => {
  if (rebateTitle) {
    return (
      <div className="mb-36">
        <img src={icon} alt="" className="m-auto icon-[122px]"></img>
        <p className="text-xl text-center text-gray-dark">{rebateTitle}</p>
        <p className="text-center">{rebateDescription}</p>
      </div>
    );
  }

  return null;
};

export default MatchingRebateCard;
